<template>
  <module-list-layout
      :createAction="true"
      :headerActionClass="(userUsingPrivateRate)? 'voip-call-test-status pending p-2 border-0' : 'voip-call-test-status awaiting-action p-2 border-0' "
      :headerActionText="(userUsingPrivateRate)? 'Create Private Rate' : 'Create Default Rate'"
      :headerActionTranslate="false"
      :module="module"
      :title="customerDisplayName + ' Rates ' + userRateStatus"
      class="p-2 border-0"
      headerActionType="info"
      style="box-shadow: none" v-if="amReady">

    <el-dialog :append-to-body="true" :visible.sync="dialogVisible" @close="reloadList" title="" top="5vh" width="75%">
      <moduleForm
          :bindingForView="true"
          :customerUserId="customerUserId"
          :dataToBind="dataToBind"
          :edit-mode="editMode"
          :formHeader="true"
          :formTitle="'Add Rate to ' + customerDisplayName"
          :moduleDeleteAction='moduleFormDeleteAction'
          :on-create-callback="afterCreate"
          :on-edit-callback="afterEdit"
          :profilesList="profilesList"
          :userUsingPrivateRate="userUsingPrivateRate == 1"
          v-if="dialogVisible"></moduleForm>

      <uploadDocumentRate :customerDisplayName="customerDisplayName" :customerUserId="customerUserId" :editMode="false"
                          :userUsingPrivateRate="userUsingPrivateRate == 1"
                          v-if="!editMode"></uploadDocumentRate>
    </el-dialog>

    <div class="row pl-3 pr-3">
      <div class="col-12 col-md-4 mt-0 pt-1">
        <dg-text-field
            :field_span="22"
            :label_span="22"
            :liveUpdate="true"
            @amUpdated="userSearchUpdated"
            field_mark=""
            placeholder="search preifx,vendor,destination"></dg-text-field>
      </div>
      <div class="col-12 col-md-5">
        <pagination
            :currentPage="currentPage"
            :navigateHandler="navigateToPage"
            :page-count="getPagesCount()"
            paginateClass=""></pagination>
      </div>
      <div class="col-12 col-md-2 text-left">
        <dg-confirm-button
            icon=""
            :loading="false"
            :onConfirm="activateAllNewRates"
            text="Activate All New Rates"
            :translate="false"
            type="success mt-1"
            fieldSize="mini"></dg-confirm-button>
      </div>
    </div>

    <app-ag-grid :agGrid="agGrid"></app-ag-grid>
  </module-list-layout>
</template>

<script>

import actionsCell from './ag-grid/ActionsCell'
import isRateActive from './ag-grid/IsRateActive.vue'
import isFixedRate from './ag-grid/IsFixedRate'
import RateCell from './ag-grid/RateCell.vue'
import module from './../../index.js'
import {notify} from '@/system-services/notify.js'


export default {
  components: {
    uploadDocumentRate: () => import('./../../upload-document-rate/View'),
    pagination: () => import('@/components/pagination/View.vue'),
    moduleForm: () => import('../../form/View'),
    moduleListLayout: () => import('@/modules-config/layouts/list/View.vue')
  },
  props: {
    editLiveTrafficRate: {
      required: false,
      default: false
    },
    showOnlyFixedRates: {
      required: true
    },
    showOnlyNewRates: {
      required: true
    },
    customerUserId: {
      required: true
    },
    customerDisplayName: {
      required: true
    },
    userRateStatus: {
      required: true
    },
    userUsingPrivateRate: {
      required: true
    }
  },
  data() {
    return {
      userSearch: '',
      userSearchTimeOut: null,
      amReady: true,
      module: {
        ...module
      },
      currentPage: 1,
      pageChunkSize: 12,
      pageCount: 1,
      profilesList: [],
      editMode: false,
      dialogVisible: false,
      recordsCounter: 0,
      dataToBind: null,
      rowToEdit: null,
      agGrid: {
        pagination: false,
        enableRtl: this.$langConfig.dir == 'rtl',
        agGridStyle: 'width: 100%; height: 650px; padding: 0',
        agGridClass: 'ag-theme-material',
        gridOptions: {
          suppressCellSelection: true,
          onGridReady: function (params) {
          
            params.api.sizeColumnsToFit()
          }
        },
        columnDefs: [
          {
            field: 'vendor',
            headerName: 'Vendor',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            field: 'prefix',
            headerName: 'Prefix',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            field: 'division',
            width: 150,
            headerName: 'Division',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            field: 'destination',
            headerName: 'Destination',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            field: 'dialcode',
            width: 130,
            headerName: 'Dialcode',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            field: 'rate',
            width: 250,
            headerName: 'Rate',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true,
            cellRendererFramework: $vue.extend(RateCell),
            cellRendererParams: {
              props: {
                actionsHandler: this.actionsHandler
              }
            }
          },
          {
            field: 'isActive',
            width: 110,
            headerName: 'Active',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true,
            cellRendererFramework: $vue.extend(isRateActive),
            cellRendererParams: {
              props: {
                actionsHandler: this.actionsHandler
              }
            }
          },
          {
            field: 'is_fixed',
            width: 110,
            headerName: 'Fixed',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true,
            cellRendererFramework: $vue.extend(isFixedRate),
            cellRendererParams: {
              props: {
                actionsHandler: this.actionsHandler
              }
            }
          },
          {
            width: 110,
            headerName: this.$ml.get('actions'),
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            cellRendererFramework: $vue.extend(actionsCell),
            cellRendererParams: {
              props: {
                actionsHandler: this.actionsHandler
              }
            }
          }
        ],
        rowData: []
      }
    };
  },
  beforeMount() {
    this.currentPage = 1
    this.getEntityListData(this.currentPage)
  },
  methods: {
    ...$mapActions('voip-customer-rate-api', {getEntityList: 'list'}),
    activateAllNewRates () {
      this.activateAllNewRatesAction({customerUserId: this.customerUserId}).then( r => {
        this.reloadList()
      })
    },
    reloadList() {
      this.getEntityListData(1)
    },

    ...$mapActions('voip-customer-rate-api', {
      updateCustomerRate: 'update',
      activateAllNewRatesAction: 'activateAllNewRates'
    }),
    setIsRateActive(params) {
      let data = {
        is_active: (params.value == true) ? 1 : 0,
      }
      this.updateCustomerRate({data, id: params.id})
    },
    setIsFixedRate(params) {
      let data = {
        is_fixed: (params.value == true) ? 1 : 0,
      }
      this.updateCustomerRate({data, id: params.id})
    },
    getEntityListData(page) {
      
      let data = {
        page: page,
        search: this.userSearch,
        only_new_rates: this.showOnlyNewRates,
        only_fixed_rates: this.showOnlyFixedRates,
        edit_live_traffic_rate: this.editLiveTrafficRate
      }
      
      if (this.userUsingPrivateRate) {
       
        data.customerUserId = this.customerUserId
      }

      this.getEntityList(data).then(response => {
        
        this.buildAgGridData(response)
      })
      this.currentPage = page
    },
    buildAgGridData(response) {
     
      this.agGrid.rowData = response.rows
      this.recordsCounter = response.count
      this.amReady = true
    },
    userSearchUpdated(field) {
      // this.agGrid.gridApi.setQuickFilter(val);
      let val = field.field.field_value
      this.userSearch = val
      clearTimeout(this.userSearchTimeOut)
      this.userSearchTimeOut = setTimeout(() => {
        this.getEntityListData(1) //this.agGrid.gridApi.setQuickFilter(val);
      }, 200)
    },
    
    scrollToTop() {
      document.body.scrollTop = 0;
      document.getElementById('content-main-container').scrollTop = 0;
    },
    getPagesCount() {
      return Math.ceil(this.recordsCounter / this.pageChunkSize)
    },
    navigateToPage(page) {
      this.getEntityListData(page)
    },
    refreshGrid() {
      this.agGrid.gridOptions.api.setRowData(this.agGrid.rowData)
    },
    afterEdit(updatedData) {
      // getting a rowNode by index
      // this.agGrid.gridApi.getDisplayedRowAtIndex(0).setData({})

      this.agGrid.rowData[this.rowToEdit] = updatedData;
      this.dialogVisible = false;
      this.refreshGrid();
    },
    moduleFormDeleteAction() {
      this.removeAction({
        data: this.dataToBind,
        rowIndex: this.rowToEdit
      })
      this.dialogVisible = false;
    },
    afterCreate(newEntity) {
      this.agGrid.rowData.push(newEntity);
      this.dialogVisible = false;
      this.refreshGrid();
    },
    createAction(params) {
      this.dialogVisible = true;
      this.editMode = false;
      this.dataToBind = null;
      this.rowToEdit = null;
      // this.$router.push({ name: 'module->voip-customer-rate->view', params: { id: params.data.id}})
    },
    editAction(params) {
      this.dialogVisible = true;
      this.editMode = true;
      this.dataToBind = params.data;
      this.rowToEdit = params.rowIndex;
    },
    removeAction(params) {
      this.$store.dispatch(this.module.info.name + '-api/remove', {id: params.data.id}).then(response => {
        this.agGrid.rowData.splice(params.rowIndex, 1);
        this.refreshGrid();
        this.recordsCounter -= 1;
        notify({
          type: 'success',
          title: this.$ml.get('deleted'),
        });
      })
    },
    actionsHandler(command, params) {
      this[command](params)
    }
  }
}
</script>
